try {
  const headers = document.querySelectorAll("h1, h2, h3");
  headers.forEach(elem => elem.innerHTML = elem.innerHTML.replace(/(<p[^>]+?>|<p>|<\/p>)/img, ''));
} catch (e) {

}


